<template>
    <div
        class="th-checkbox"
        :class="classCheckbox"
    >
        <div class="checkbox-wrapper">
            <input
                :id
                v-model="model"
                :name="id"
                class="checkbox"
                type="checkbox"
            />

            <label
                :for="id"
                class="label"
            >
                <slot>{{ label }}</slot>
            </label>
        </div>

        <FieldError
            v-if="error"
            :error
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNextId } from '@/helpers/registry'

import FieldError from '@/components/ui/inputs/ThFieldError.vue'

const {
    label = undefined,
    labelOnLeft = false,
    error = undefined,
    large = false,
} = defineProps<{
    label?: string
    labelOnLeft?: boolean
    error?: string
    large?: boolean
}>()

const id = `checkbox-${useNextId()}`

const model = defineModel<boolean | null | undefined>({
    required: true,
})

const classCheckbox = computed(() => ({
    error,
    'left-label': labelOnLeft,
    large,
}))
</script>

<style lang="scss" scoped>
.th-checkbox {
    position: relative;
    margin: 0 0 10px;

    .checkbox-wrapper {
        display: flex;
        align-items: flex-start;
    }

    &.left-label {
        .checkbox-wrapper {
            flex-direction: row-reverse;
        }
    }

    .checkbox {
        flex-shrink: 0;
        position: relative;
        width: 18px;
        height: 18px;
        border: 1px solid rgba($slate, 0.5);
        border-radius: 4px;
        cursor: pointer;

        &:checked {
            background: $blue url('@/assets/icons/checkmark-white.svg');
            background-size: 10px auto;
            background-repeat: no-repeat;
            background-position: 3px 3px;
        }
    }

    .label {
        font-family: $sectra-font-stack;
        font-style: normal;
        font-weight: 400;
        color: $slate;
        font-size: 0.75rem;
        line-height: 1.4em;
        cursor: default;
        padding: 0 10px;

        a {
            text-decoration: underline;
            cursor: pointer;
        }
    }

    &.error {
        .checkbox {
            &:not(:checked) {
                border-color: rgba($red, 0.5);
            }
        }
    }

    &.large {
        .checkbox {
            width: 22px;
            height: 22px;

            &:checked {
                background-size: 14px auto;
                background-position: 4px 4px;
            }
        }

        .label {
            font-size: 1rem;
            padding: 0 12px;
        }
    }
}
</style>
